export enum DataSourceStatus {
    Current = 'current',
    Archived = 'archived',
}